import { ROLES } from "./roles";

export const ROUTE_PERMISSIONS = {
  "/details": [ROLES.Admin],

  "/departments": [ROLES.SuperAdmin],
  "/officer-list": [ROLES.SuperAdmin, ROLES.Admin],
  "/assessment": [ROLES.Admin, ROLES.NodalOfficer],

  // 🧾 Shared (multiple roles allowed)
  "/change-password": Object.values(ROLES),
  "/rsa": Object.values(ROLES),
  "/404": Object.values(ROLES),
  "/maintenance": Object.values(ROLES),
};
